import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

import '../../../css/placesList/games.scss';
import '../../core/services/gameSortSerivce';

// import main module definition.
import placesListModule from './placesListModule';

importFilesUnderPath(require.context('./constants/', true, /\.js$/));
importFilesUnderPath(require.context('./directives/', true, /\.js$/));
importFilesUnderPath(require.context('./controllers/', true, /\.js$/));
importFilesUnderPath(require.context('./services/', true, /\.js$/));

const templateContext = require.context('./', true, /\.html$/);

const templates = templateCacheGenerator(angular, 'placesListHtmlTemplateApp', templateContext);

// self manual initialization
angular.element(function() {
  angular.bootstrap('#places-list-container', [placesListModule.name, templates.name]);
});
